import { SearchFileDTO } from "../DTO/searchFileDTO";
import { Customer } from "./customer";
import { MoovDefinition } from "./moovDefinition";

export class SearchFile{
    public id!: number;
    public name!: string;
    public customerId!: number;
    public customer!: Customer;
    public userId!: number;
    public interfaceType!: number;
    public sourceIP!: string;
    public status!: number;
    public moovDefinitionId!: number;
    public moovDefinition!: MoovDefinition;
    public moovConfigurationId!: number;
    public moovInstanceId!: number;
    public filepath!: string;
    public receivedAt!: Date;
    public isOutputFile!: boolean;
    public purgeAfter!: Date;
    public purgedAt!: Date;

    public static mapFromDTO(param: SearchFileDTO): SearchFile{
        if (!param) throw new Error("param is null");
        let obj = new SearchFile();
        try{
            obj.id = param.id;
            obj.name = param.name;
            obj.customerId = param.customerId;
            obj.userId = param.userId;
            obj.interfaceType = param.interfaceType;
            obj.sourceIP = param.sourceIP;
            obj.status = param.status;
            obj.moovDefinitionId = param.moovDefinitionId!;
            obj.moovConfigurationId = param.moovConfigurationId!;
            obj.moovInstanceId = param.moovInstanceId!;
            obj.filepath = param.filepath;
            obj.receivedAt = new Date(param.receivedAt);
            obj.isOutputFile = param.isOutputFile;
            obj.purgeAfter = new Date(param.purgeAfter);
            if(param.purgedAt) new Date(param.purgedAt);


        }
        catch(e){
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param: SearchFile): SearchFileDTO{
        if(!param) throw new Error("param is null");
        let dto = new SearchFileDTO();
        try{
            dto.id = param.id;
            dto.name = param.name;
            dto.customerId = param.customerId;
            dto.userId = param.userId;
            dto.interfaceType = param.interfaceType;
            dto.sourceIP = param.sourceIP;
            dto.status = param.status;
            dto.moovDefinitionId = param.moovDefinitionId;
            dto.moovConfigurationId = param.moovConfigurationId;
            dto.moovInstanceId = param.moovInstanceId;
            dto.filepath = param.filepath;
            dto.receivedAt = param.receivedAt.toISOString();
            dto.isOutputFile = param.isOutputFile;
            dto.purgeAfter = param.purgeAfter.toISOString();
            if(param.purgedAt)dto.purgedAt.toString();
        }
        catch(e){
            console.log(e);
            
        }
        return dto;
    }

    get displayInterfaceType(){
        switch(this.interfaceType){
            case 0:
                return "Manual upload";
            case 1:
                return "SFTP upload";
            case 2:
                return "External API";
            case 3:
                return "Email";
            case 4:
                return "Queued from other moov";
            case 5:
                return "Dropbox upload";
            default:
                return "";
        }
    }

    get displayStatus() {
        if(this.moovInstanceId==null){
            switch(this.status){
                case 1:
                    return "Processed";
                case 2:
                    return "Error: no moov configuration found";
                case 3:
                    return "Error: multiple moov configurations found";
                case 4:
                    return "Error: inactive moov configuration";
                case 5:
                    return "Error: inactive customer";
                case 6:
                    return "Error: file does not match file definition";
                default:
                    return "";
            }
        }
        else{
            switch (this.status) {
                case 0:
                    return "Created";
                case 1:
                    return "In Process";
                case 2:
                    return "Completed";
                case 3:
                    return "Failed";
                case 4:
                    return "Deleted";
                case 5:
                    return "Suspended";
                default:
                    return "";
            }
        }

        
    }

    get statusColor() {
        if(this.moovInstanceId==null && this.status != 1){
            return "red";
        }
        else if(this.status == 3 || this.status == 5 || this.status == 4){
            return "red";
        }
        else return "black";
    
    }

    get customerName(){
        return this.customer?.name;
    }

    get moovDefinitionName(){
        return this.moovDefinition?.name;
    }

}